
import { Injectable } from '@angular/core';
import { NbMenuItem } from '@nebular/theme';
import { AuthService } from '../auth/auth.service';


@Injectable()
export class MenuItemService {


  constructor(private authService: AuthService) { 



  }


  /* getMenuItems(): NbMenuItem[] {

    let result = [

      
      {
        title: 'Licence',
        icon: 'people',
        link: '/key/liste'
      },

    ];

    return result;

  } */


  getMenuItems(): NbMenuItem[] {

    let result = [

      /* {
        title:'Pages',
        icon: 'browser',
        // link: '/cms/pages',
      }, */
      {
        title: 'Licence',
        icon: 'people',
        link: '/key/liste'
      },
      {
        title: 'Offres',
        icon: 'briefcase',
        link: '/offre/liste'
      },
      {
        title: 'Base de données',
        icon: 'people',
        link: '/database/liste'
      },
      {
        title: 'Appareils',
        icon: 'briefcase',
        link: '/device/liste',
      },
      {
        title: 'Ecoles',
        icon: 'people',
        link: '/ecole/liste'
      },
      {
        title: 'Formations',
        icon: 'award-outline',
        link: '/formation/liste',
      },
      {
        title: 'Options',
        icon: 'options',
        /*link: '/critere/liste',*/
        children: [
          {
            title: 'Admissions',
            link: '/critere/liste/admissibility',
          },
          {
            title: 'Niveau Requis',
            link: '/critere/liste/niveau',
          },
          {
            title: 'Cycles',
            link: '/critere/liste/cycle',
          },
          {
            title: 'Types d \'école',
            link: '/critere/liste/type_ecole',
          },
          {
            title: 'Pays',
            link: '/critere/liste/pays',
          },
          {
            title: 'Secteurs ecoles',
            link: '/critere/liste/secteur',
          },
          {
            title: 'Catégories formation',
            link: '/critere/liste/catformation',
          },
          {
            title: 'Dates rentrée',
            link: '/critere/liste/daterentree',
          },
    
          {
            title: 'Secteurs metiers',
            link: '/critere/liste/secteur_metier',
          },
          {
            title: 'Salaires metiers',
            link: '/critere/liste/salaire',
          },
          {
            title: 'Alternance',
            link: '/critere/liste/alternance',
          },
          {
            title: 'Sélectivité des études',
            link: '/critere/liste/selectivite',
          },
          {
            title: 'Insertion professionnelle',
            link: '/critere/liste/insertion',
          },
          {
            title: 'Type de contrat',
            link: '/critere/liste/type_contrat',
          },
    
        ],
      },
      {
        title: 'Métiers',
        icon: 'briefcase',
        link: '/metier/liste',
      },
      {
        title: 'Annonces job/stage',
        icon: 'bell',
        link: '/job/liste',
      },
      {
        title: 'Articles/Forum',
        icon: 'home-outline',
        children: [
          /* {
            title: 'Blog',
            link: '/articles/listing/blog',
          },
          {
            title: 'Orientation',
            link: '/articles/listing/orientation',
          },
          {
            title: 'Mentoring',
            link: '/articles/listing/mentoring',
          }, */
          {
            title: 'Tous les articles',
            link: '/articles/listing/blog',
          },
          {
            title: 'categories',
            link: '/category/liste/article',
          },
          
          {
            title: 'Commentaires',
            link: '/commentaire',
          },
          
        ],
        
      },
    
    /*  {
        title: 'categories',
        icon: 'hard-drive',
        link: '/category/liste',
      }, */
    
    /*  {
        title: 'Menu',
        icon: 'menu',
        link: '/menus/liste',
      }, */
    
      /* {
        title: 'Projet',
        icon: 'layout-outline',
        link: '/projet/liste',
      },
      {
        title: 'Souscription',
        icon: 'shopping-cart-outline',
        link: '/souscription/liste',
      }, */
      {
        title: 'Médiathèque',
        icon: 'folder',
        link: '',
      },
    
      {
        title: 'Utilisateurs',
        icon: 'person',
        link: '/utilisateurs/liste',
      },
    
      {
        title: 'Paramètres',
        icon: 'settings-2',
        link: '/setting/general',
      },
      /* 
      {
        title: 'Paramètres',
        icon: 'settings-2',
        children: [
          {
            title: 'generale',
            link: '/setting/general',
          },
          {
            title: 'menu',
            link: '/setting/menu',
          },
          {
            title: 'network',
            link: '/setting/network',
          },
        
          {
            title: 'page',
            link: '/setting/page',
          },
          {
            title: 'stat',
            link: '/setting/stat',
          },
        ], 
      },*/
    
      // {
      //   title: 'E-commerce',
      //   icon: 'shopping-cart-outline',
      //   link: '/dashboard',
      //   home: true,
      // },
    
      
      // {
      //   title: 'IoT Dashboard',
      //   icon: 'home-outline',
      //   link: '/iot-dashboard',
      // },
      // {
      //   title: 'FEATURES',
      //   group: true,
      // },
      // {
      //   title: 'Layout',
      //   icon: 'layout-outline',
      //   children: [
      //     {
      //       title: 'Stepper',
      //       link: '/layout/stepper',
      //     },
          
      //     {
      //       title: 'List',
      //       link: '/layout/list',
      //     },
      //     {
      //       title: 'Infinite List',
      //       link: '/layout/infinite-list',
      //     },
      //     {
      //       title: 'Accordion',
      //       link: '/layout/accordion',
      //     },
      //     {
      //       title: 'Tabs',
      //       pathMatch: 'prefix',
      //       link: '/layout/tabs',
      //     },
      //   ],
      // },
      // {
      //   title: 'Forms',
      //   icon: 'edit-2-outline',
      //   children: [
      //     {
      //       title: 'Form Inputs',
      //       link: '/forms/inputs',
      //     },
      //     {
      //       title: 'Form Layouts',
      //       link: '/forms/layouts',
      //     },
      //     {
      //       title: 'Buttons',
      //       link: '/forms/buttons',
      //     },
      //     {
      //       title: 'Datepicker',
      //       link: '/forms/datepicker',
      //     },
      //   ],
      // },
      // {
      //   title: 'UI Features',
      //   icon: 'keypad-outline',
      //   link: '/ui-features',
      //   children: [
      //     {
      //       title: 'Grid',
      //       link: '/ui-features/grid',
      //     },
      //     {
      //       title: 'Icons',
      //       link: '/ui-features/icons',
      //     },
      //     {
      //       title: 'Typography',
      //       link: '/ui-features/typography',
      //     },
      //     {
      //       title: 'Animated Searches',
      //       link: '/ui-features/search-fields',
      //     },
      //   ],
      // },
      // {
      //   title: 'Modal & Overlays',
      //   icon: 'browser-outline',
      //   children: [
      //     {
      //       title: 'Dialog',
      //       link: '/modal-overlays/dialog',
      //     },
      //     {
      //       title: 'Window',
      //       link: '/modal-overlays/window',
      //     },
      //     {
      //       title: 'Popover',
      //       link: '/modal-overlays/popover',
      //     },
      //     {
      //       title: 'Toastr',
      //       link: '/modal-overlays/toastr',
      //     },
      //     {
      //       title: 'Tooltip',
      //       link: '/modal-overlays/tooltip',
      //     },
      //   ],
      // },
      // {
      //   title: 'Extra Components',
      //   icon: 'message-circle-outline',
      //   children: [
      //     {
      //       title: 'Calendar',
      //       link: '/extra-components/calendar',
      //     },
      //     {
      //       title: 'Progress Bar',
      //       link: '/extra-components/progress-bar',
      //     },
      //     {
      //       title: 'Spinner',
      //       link: '/extra-components/spinner',
      //     },
      //     {
      //       title: 'Alert',
      //       link: '/extra-components/alert',
      //     },
      //     {
      //       title: 'Calendar Kit',
      //       link: '/extra-components/calendar-kit',
      //     },
      //     {
      //       title: 'Chat',
      //       link: '/extra-components/chat',
      //     },
      //   ],
      // },
      // {
      //   title: 'Maps',
      //   icon: 'map-outline',
      //   children: [
      //     {
      //       title: 'Google Maps',
      //       link: '/maps/gmaps',
      //     },
      //     {
      //       title: 'Leaflet Maps',
      //       link: '/maps/leaflet',
      //     },
      //     {
      //       title: 'Bubble Maps',
      //       link: '/maps/bubble',
      //     },
      //     {
      //       title: 'Search Maps',
      //       link: '/maps/searchmap',
      //     },
      //   ],
      // },
      // {
      //   title: 'Charts',
      //   icon: 'pie-chart-outline',
      //   children: [
      //     {
      //       title: 'Echarts',
      //       link: '/charts/echarts',
      //     },
      //     {
      //       title: 'Charts.js',
      //       link: '/charts/chartjs',
      //     },
      //     {
      //       title: 'D3',
      //       link: '/charts/d3',
      //     },
      //   ],
      // },
      // {
      //   title: 'Editors',
      //   icon: 'text-outline',
      //   children: [
      //     {
      //       title: 'TinyMCE',
      //       link: '/editors/tinymce',
      //     },
      //     {
      //       title: 'CKEditor',
      //       link: '/editors/ckeditor',
      //     },
      //   ],
      // },
      // {
      //   title: 'Tables & Data',
      //   icon: 'grid-outline',
      //   children: [
      //     {
      //       title: 'Smart Table',
      //       link: '/tables/smart-table',
      //     },
      //     {
      //       title: 'Tree Grid',
      //       link: '/tables/tree-grid',
      //     },
      //   ],
      // },
      // {
      //   title: 'Miscellaneous',
      //   icon: 'shuffle-2-outline',
      //   children: [
      //     {
      //       title: '404',
      //       link: '/miscellaneous/404',
      //     },
      //   ],
      // },
      // {
      //   title: 'Auth',
      //   icon: 'lock-outline',
      //   children: [
      //     {
      //       title: 'Login',
      //       link: '/auth/login',
      //     },
      //     {
      //       title: 'Register',
      //       link: '/auth/register',
      //     },
      //     {
      //       title: 'Request Password',
      //       link: '/auth/request-password',
      //     },
      //     {
      //       title: 'Reset Password',
      //       link: '/auth/reset-password',
      //     },
      //   ],
      // },
    ];

    return result;

  }


}

